import { useEffect } from 'react';

/**
 * Hook para capturar erros globais não tratados
 * Melhora a observabilidade da aplicação
 */
export const useGlobalErrorHandler = () => {
  useEffect(() => {
    // Handler para erros JavaScript não capturados
    const handleError = (event) => {
      const error = event.error;
      
      console.group(`🚨 Erro global capturado`);
      console.error('Erro:', error);
      console.error('Arquivo:', event.filename);
      console.error('Linha:', event.lineno);
      console.error('Coluna:', event.colno);
      console.groupEnd();
    };

    // Handler para promises rejeitadas não tratadas
    const handleUnhandledRejection = (event) => {
      console.group(`🚨 Promise rejeitada não tratada`);
      console.error('Motivo:', event.reason);
      console.error('Promise:', event.promise);
      console.groupEnd();

      // Prevenir que o erro apareça no console (opcional)
      // event.preventDefault();
    };

    // Registrar os handlers
    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    // Cleanup
    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, []);
};